module.exports = __webpack_public_path__ + "static/media/downgrade_success.2474d4ab.svg";